import React from 'react';
const TotalAmountsTable = ({ data }) => {
    return (React.createElement("div", { className: "totalAmountsTable" }, data.map((item, index) => (React.createElement("div", { key: index },
        React.createElement("div", null,
            React.createElement("div", { className: "totalAmountsTable__value" }, item.value),
            React.createElement("div", { className: "totalAmountsTable__label" }, item.label)))))));
};
export default TotalAmountsTable;
